"use client";

import { useRef, useEffect } from "react";
import { explainers } from "@/components/quiz/explainers";
import explainersData from "@/lib/data/explainers.json";

interface QuizExplainerProps {
  currentExplainerIndex: number;
  currentExplainers: string[];
  onNext: () => void;
}

export function QuizExplainer({
  currentExplainerIndex,
  currentExplainers,
  onNext,
}: QuizExplainerProps) {
  const isNavigatingRef = useRef(false);

  // Reset navigation flag when explainer changes
  useEffect(() => {
    isNavigatingRef.current = false;
  }, [currentExplainerIndex]);

  if (currentExplainerIndex === null || currentExplainers.length === 0) {
    return null;
  }

  const currentExplainerId = currentExplainers[currentExplainerIndex] ?? "";

  // Find the explainer data from the JSON file
  const currentExplainer = explainersData.explainers.find(
    (exp) => exp.id === currentExplainerId
  );

  if (!currentExplainer) {
    return null;
  }

  // Get the component from the existing mapping
  const ExplainerComponent = explainers[currentExplainerId];

  if (!ExplainerComponent) {
    return null;
  }

  const handleNext = () => {
    // Prevent rapid clicks
    if (isNavigatingRef.current) return;
    isNavigatingRef.current = true;
    // actor.send({ type: "NEXT" });
    onNext();
  };

  // Pass slug so explainers can determine workflow (ng if slug is bqnxse or kqrawo)
  return (
    <ExplainerComponent
      {...currentExplainer}
      handleNext={handleNext}
    />
  );
}
